import styled, { css } from "styled-components";
import Colors from "constants/Colors";
import { Breakpoints } from "constants/Breakpoints";

import Icon from "components/Icon";
import {
  QuicksandBold,
  FontWeight,
  Text
} from "components/Text";
import { Row, Col } from "components/Grid";
import AIOLogo from "components/Icon/png/AIO-logo.png";
import DentalisLogo from "components/Icon/png/Dentalis-logo.png";

export const Container = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: auto;
  padding: 20px 20px 50px 20px;
  display: block;
//  flex-direction: column;
  ::-webkit-scrollbar {
    background: ${Colors.WHITE};
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }
`;

export const InsurerLogo = styled.img`
  display:block;
  width:92px;
  height:40px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5px;
  margin-bottom: 11px; 

  @media screen and (max-width: ${Breakpoints.md}) {
    width: 92px;
    height: 40px;
  }
  @media (max-width: ${Breakpoints.sm}) {
    width: 92px;
    height: 40px;
  }
  @media (max-width: ${Breakpoints.xs}) {
    width: 92px;
    height: 40px;
  }
`;

export const Logo = styled.div`
  width: 280px;
  height: 70px;
  ${({user})=> user === process.env.REACT_APP_USER_AIO_DENTALIS 
    ? `background: url(${DentalisLogo}) no-repeat center;`
    :` background: url(${AIOLogo}) no-repeat center; `}
  /* background: url(${AIOLogo}) no-repeat center; */
  background-size: 100% 100%;
  display:block ;

  @media (max-width: ${Breakpoints.xl}) {
    width: 280px;
    height: 70px;
  }
  @media (max-width: ${Breakpoints.md}) {
    width: 200px;
    height: 70px;
  }
  @media (max-width: ${Breakpoints.xs}) {
    width: 180px;
    height: 50px;
  }
`;


export const Title = styled(Text)`
  margin-top: 0px;
  font-size: 30px;
  font-weight: ${FontWeight.Bold};
  color: ${Colors.TITLE};
  @media (max-width: ${Breakpoints.xl}) {
    font-size: 30px;
  }
  @media (max-width: ${Breakpoints.md}) {
    font-size: 28px;
  }
  @media (max-width: ${Breakpoints.xs}) {
    font-size: 22px;
  }
`;

export const Subtitle2 = styled(Text)`
  margin-top: 15px;
  font-size: 16px;
  font-weight: ${FontWeight.Medium};
  color: ${Colors.SUBTITLE};
  display: block;
  @media (max-width: ${Breakpoints.xl}) {
    font-size: 16px;
  }
  @media (max-width: ${Breakpoints.md}) {
    font-size: 14px;
  }
  @media (max-width: ${Breakpoints.xs}) {
    font-size: 11px;
    margin-top: 5px;
  }
`;

export const Head = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  @media (max-width: ${Breakpoints.xs}) {
   flex-direction: column;
   align-items: flex-start;
  }
`;

export const Heading = styled.h2`
  color: ${Colors.GRAY[6]};
  padding-left: 10px;
`;

export const LabelTitle = styled.p`
  ${QuicksandBold}
  font-size: 14px;
  line-height: 21px;
  text-transform: uppercase;
  color: #0f0c35;
  margin: 0px;
`;

export const LabelText = styled.p`
  ${QuicksandBold}
  font-size: 18px;
  line-height: 27px;
  color: #2c2a28;
  margin: 0px;
`;

export const RowStyled = styled(Row)`
  margin-bottom: 10px;
`;

export const ColStyled = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -10px;
  padding-top: 12px;
  padding-bottom: 12px;
  cursor: pointer;
  ${({ isActive }) =>
    isActive ? "background-color: white;" : "background-color: #B8B9BB;"}
`;

export const LabelTypePlan = styled.p`
  ${QuicksandBold}
  font-size: 16px;
  line-height: 24px;
  margin: 0px;

  @media (max-width: ${Breakpoints.sm}) {
    font-size: 14px;
  }
  @media (max-width: ${Breakpoints.xs}) {
    font-size: 12px;
  }
  @media (max-width: ${Breakpoints.xxs}) {
    font-size: 10px;
  }

  ${({ isActive }) =>
    isActive ? "color: #2c2a28;" : "color: #FFFFFF;"}
  
`;

export const LabelInfoPlan = styled.p`
  ${QuicksandBold}
  margin: 0px;
  display: flex;
  align-items: center;
  width: 110%; 
  padding-right: 10%;

  font-size: ${({ fs }) => fs || "14"}px;
  ${({ nbb }) => (nbb ? "" : "border-bottom: 2px solid #C4C4C4;")}
  line-height: ${({ lh }) => lh || "21"}px;
  color: ${({ color }) => color || "#A3A3A3"};
  ${({ center }) =>
    center ? "justify-content: center; text-align: center;" : ""}

  ${({ pt }) => (pt ? `padding-top: ${pt}px;` : "")}
  ${({ pb }) => (pb ? `padding-bottom: ${pb}px;` : "")}
  ${({ pl }) => (pl ? `padding-left: ${pl}px;` : "")}
  ${({ pr }) => (pr ? `padding-right: ${pr}px;` : "")}
  ${({ mnh }) => (mnh ? `min-height: ${mnh}px;` : "")}
  ${({ mxh }) => (mxh ? `max-height: ${mxh}px;` : "")}
  ${({ flexEnd }) => (flexEnd ? "align-items: flex-end;" : "")}
  ${({ largeWidth }) =>
    largeWidth
      ? "@media screen and (min-width: 768px) { width: 110%; padding-right: 10%; }"
      : ""}
`;

export const ButtonContract = styled.div`
  padding-left: 16.5px;
  padding-right: 15.5px;
  padding-bottom: 14px;
  padding-top: 14px;
  background-color: ${Colors.SECONDARY};
  width: 131px;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 32px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  cursor: pointer;
  border-bottom: 2px solid #c4c4c4;
`;

export const Notice = styled.div`
  min-height: 70vh;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content:center;
  border-radius: 10px;
`;

export const DivIcon = styled.div`
  padding-top: 12px;
  padding-bottom: 13px;
  max-height: 86px;
  min-height: 85px;
  border-bottom: 2px solid #c4c4c4;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ mxh }) => (mxh ? `max-height: ${mxh}px;` : "86px;")}
  ${({ mnh }) => (mnh ? `min-height: ${mnh}px;` : "85px;")}
  ${({ isFirst }) =>
    isFirst ? "border-top: 2px solid #C4C4C4; min-height: 87px;" : ""}
  ${({ isLast }) =>
    isLast
      ? "width: 100%;"
      : "@media screen and (min-width: 768px) { width: 110%; }"}
`;

export const IconErrorOrGreen = styled(Icon)`
  ${({ isLast }) => isLast ? '' : `
  @media screen and (min-width: 768px) {
    margin-left: -10%;
  }`}
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-top: 20px;
  width: 100%;
  padding: 0px 0px 0px 20px;
`;

export const BackToList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
